<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="container px-5 mt-5">
  <div class="stepper-container row">
    <h3 class="text-secondary mb-0">
      <b>Etape {{ currentStepIndex + 1 }} sur 4</b>
    </h3>
    <h2 class="mb-0">
      <b>Formulaire : {{ currentTitle }}</b>
    </h2>
    <mat-horizontal-stepper
      aria-selected="false"
      labelPosition="bottom"
      ngClass="{{ 'last-edited-step-' + stepper.selectedIndex }}"
      [linear]="true"
      #stepper
      (selectionChange)="onStepChange($event)"
    >
      <mat-step [stepControl]="step1">
        <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        <h4>Les champs annotés d'un astérique * sont obligatoires.</h4>
        <app-situation-administrative-form [situationAdministrativeForm]="step1" (agentSelected)="updateCdisationData($event)">
        </app-situation-administrative-form>
      </mat-step>
      <mat-step [stepControl]="step2">
        <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        <h4>Les champs annotés d'un astérique sont obligatoires *</h4>
        <app-informations-renouvellement-form
          [infoRenouvellementForm]="step2"
          [cdisationData]="cdisationData"
          (formSubmit)="onChildformSubmit(2, $event)"
        ></app-informations-renouvellement-form>
      </mat-step>
      <mat-step [stepControl]="step3">
        <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        <h4>Les champs annotés d'un astérique sont obligatoires *</h4>
        <app-pertinence-existence-form
          (filesSelected)="handleFileSelected($event)"
          [pertinenceForm]="step3"
          [isFileRequired]="parentForm.get('step2')?.get('motif')?.value === 'refusContratConditions'"
          [motif]="parentForm.get('step2.motif')?.value"
        ></app-pertinence-existence-form>
      </mat-step>
      <mat-step [stepControl]="step4">
        <h4>Les champs annotés d'un astérique sont obligatoires *</h4>
        <app-destinataires-form
          [destinataireDemandeform]="step4"
          (formSubmit)="onSubmitForm()"
          [agentService]="agentServiceFonctionnel"
          [direction]="selectedDirection"
        ></app-destinataires-form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
